import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 12\" fill=\"none\" id=\"icon-down\">\n<path d=\"M4.5 12L0 6.20657L2.99957 6.21429V0.428572H5.98371L6.00043 6.21429H9L4.5 12Z\" fill=\"#10CC66\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol